import React, { Component } from 'react'
import ValidationMessage from '../view/ValidationMessage'
import FormInput from '../view/FormInput';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { get } from "lodash";
import CONSTANT from "../../constants/constant";
import CountryCodeSelect from '../view/CountryCodeSelect'
import ErrorAlert from '../view/ErrorAlert'
import UtilService from '../utils/utils';
import $ from "jquery";
import { Multiselect } from 'multiselect-react-dropdown';
import { toast } from 'react-toastify';
import UtilsService from "../../container/utils/utils";

let hideUser = false;

export default class AddPlayerForm extends Component {
    constructor(props) {
        super(props)
        this.multiselectRef = React.createRef();
        this.state = {
            currenciesData: [],
            membershipData: [],
            priceValue: '',
            addValidate:'',
            privacyOn: false
        }
    }

    async componentDidMount() {
        try {
            let response = await UtilService.getCurrencyList();
            if (response && response.countries) {
                this.setState({
                    currenciesData: response.countries
                })
            } else {
                toast.error(response?.message)
            }

            let roleId = UtilService.getUserSingleDataFromLoaclStorage('roleId');
            if((roleId === 3 || roleId === 4) && this.props.isUpdate && this.props.isOtherIdx){
                this.setState({privacyOn: true})
            }
        } catch (error) {
            console.error(error);
        }

    }

    isEnableComponent = () => {
        const { addPlayer } = this.props
        if (addPlayer.isPlayerEmailIdExist && !this.props.isUpdate) {
            return false
        } else if (this.props.isUpdate) {
            return true
        }
    }
    getLableHeading() {
        const { addPlayer, isRegister } = this.props
        if (addPlayer.isPlayerEmailIdExist && this.props.isUpdate) {
            return "Add New Member"
        }
        else if (!addPlayer.isPlayerEmailIdExist && this.props.isUpdate && UtilService.isPabsaAdmin()) {
            return "Update Member"
        } else if (isRegister) {
            return "Member Registration"
        } else if (this.props.isUpdate) {
            return "Update Member"
        }
        else
            return "Add New Member"
    }
    compareClubList = (allClubList, selectedClubs) => {
        // const selectedClubList = [];
        // allClubList && allClubList.length > 0 && allClubList.forEach((e1) => selectedClubs && selectedClubs.length > 0 && selectedClubs.forEach((e2) => {
        //     if (e1.clubId === e2) {
        //         if (selectedClubList.indexOf(e1) === -1) {
        //             selectedClubList.push(e1)
        //         }
        //     }
        // }
        // ));
        // let res = [];
        let selectedClubList;
        if (selectedClubs && selectedClubs.length > 0 && selectedClubs[0].hasOwnProperty('clubId')) {
            selectedClubList = allClubList.filter(el => {
                return selectedClubs.find(element => {
                    return element.clubId === el.clubId;
                });
            });
        } else {
            selectedClubList = allClubList.filter(el => {
                return selectedClubs.find(element => {
                    return element === el.clubId;
                });
            });
        }
        // return res;
        return selectedClubList;
    }
    // data-toggle="modal"
    // data-target="#addressForm"
    showTheModalCustom = (e) => {
        if (this.props.isRegister) {
            let ele = document.getElementById('addressForm');
            ele.classList.add('show')
            ele.style.display = 'block'
        } else {
            $('#addressForm').modal('show')
            e.target.setAttribute('data-toggle', 'modal')
            e.target.setAttribute('data-target', '#addressForm')
        }

    }

    hideConfirmModal = () => {
        let ele = document.getElementById('confirmationPlayer');
        if (ele) {
            ele.classList.add('hide')
            ele.style.display = 'none'
        }

    }

    showConfirmModal = () => {
        let ele = document.getElementById('confirmationPlayer');
        if (ele) {
            ele.classList.add('show')
            ele.style.display = 'block'
        }

    }

    handlePriceChange = (event) => {
        let value = event.target.value.trim()

        if (value.length > 10 && value * 1 > 9999999999.99) {
            return
        } else if (value * 1 < 1 && value) {
            let regex = /^[0]?\.?\d{0,2}$/
            if (!regex.test(value) && value) return
        }
        else if (value * 1 >= 1) {
            let regex = /^[1-9][0-9]*\.?\d{0,2}$/
            if (!regex.test(value) && value) return
        }

        if (event.target.value * 1 >= 0) {
            value = value.replace('+','')
            this.setState({ priceValue: value }, () =>
          this.validateForm()
        );
        }
        
      };
      
      validateForm = () => {
        if (this.state.priceValue.trim().length)
          this.setState({ addValidate: true });
        else this.setState({ addValidate: false });
    };
    addProductPrice = async() => {
        await this.props.memberCreditAmount(this.state.priceValue);
        await this.setState({priceValue:''})
    };
    isInputNumber = (event) => {
        var ch = String.fromCharCode(event.which);
        if (!(/[0-9]/.test(ch))) {
            event.preventDefault();
        }
    }
    isInputNumberWithPlus = (event) => {
        if (event.which === 43 || event.which === 45) {
            event.preventDefault();
        }
    }

    render() {
        const { addPlayer, isRegister } = this.props
        const isLoading = get(this.props, "ui.is_loding", false);
        const has_error = get(this.props, "ui.has_error", false);
        const errorMsg = get(
            this.props,
            "apiReducer.apiFailData.message",
            null
        );
        const rollValue = get(
            this.props,
            "apiReducer.apiFailData.roleId",
            null
        );
        const disable_class = (this.props.isUpdate && UtilService.isClubSuperAdmin() && this.props.isOtherIdx ? "disable_discount" : "")

        if (rollValue) {
            if (this.props.isRegister) {
                this.showConfirmModal()
            } else {
                $('#confirmationPlayer').modal('show');
            }
            this.props.ui.has_error = false;
            if (rollValue === 5) {
                hideUser = true
                this.props.apiReducer.apiFailData = null;
            } else {
                hideUser = false
                this.props.apiReducer.apiFailData = null;
            }
        } else {
            this.hideConfirmModal()
        }
        let organizationWithClub
        if (!UtilService.isPabsaAdmin()) {
            organizationWithClub = <div className="form-group mr-4 referee_div">
                <div>
                <label>Associate player with club</label>
                <div className="d-flex align-items-center position-relative">
                    <div className="position-relative red-checkbox mr-3">
                        <label
                            className="form-check-label position-relative d-flex align-items-center"
                            htmlFor="exampleCheck1"
                        >
                            <input
                                type="checkbox"
                                className="form-check-input checkbox-element"
                                name="associate_player"
                                checked={addPlayer.associate_player}
                                disabled={this.props.isUpdate ? true : false}
                                onChange={this.props.handleChangeEvent}
                            />
                            <span className="checkmark mr-2"></span>
                            My club
                        </label>
                    </div>
                </div>
                </div>
                <div>
                <label></label>
                <div className="d-flex align-items-center position-relative">
                    <div className="position-relative red-checkbox mr-3">
                        <label
                            className="form-check-label position-relative d-flex align-items-center"
                            htmlFor="exampleCheck1"
                        >
                            <input
                                type="checkbox"
                                className="form-check-input checkbox-element"
                                name="isReferee"
                                checked={addPlayer.isReferee}
                                // disabled={this.props.isUpdate ? true : false}
                                onChange={this.props.handleChangeEvent}
                            />
                            <span className="checkmark mr-2"></span>
                            Can be a Referee
                        </label>
                    </div>
                </div>
                </div>
            </div>
        } else {
            if (this.props.clubNameList != null) {
                var options
                var clubNameInUpdate = []
                if (this.props.clubNameList.length > 0) {
                    const clubNameList = JSON.parse(this.props.clubNameList)
                    if (this.props.isUpdate) {
                        clubNameInUpdate = this.compareClubList(clubNameList.clubs, addPlayer.clubs)
                    }
                    options = < Multiselect
                        options={clubNameList.clubs}
                        displayValue="name"
                        showCheckbox={true}
                        groupBy=""
                        selectedValues={clubNameInUpdate}
                        onSelect={this.props.onselect} // Function will trigger on select event
                        onRemove={this.props.onremove}
                        ref={this.multiselectRef} // Function will trigger on remove event
                    />

                    setTimeout(() => {
                        let ele = document.querySelectorAll('.optionContainer li')
                        Object.keys(ele).map((key, idx) => {
                            let createEle = document.createElement('span')
                            ele[key].appendChild(createEle)
                        })
                    }, 1000);

                }
            }
            organizationWithClub = <div className="form-group w-100">
                <label>Club Name</label>
                <div className="d-flex align-items-center position-relative">

                    <div className="position-relative red-checkbox flex-1">
                        {options}
                        {/* <select className="form-control pr-4 enable-if-exists"
                            name="clubId"
                            onChange={this.props.handleChangeEvent}
                            value={clubNameInUpdate}
                        >
                            <option value={0} key='None'>{this.props.isUpdate ? clubNameInUpdate : 'NONE'}</option>
                            {options}
                        </select> */}
                        <i className="arrow-icon"></i>
                    </div>
                </div>

            </div>
        }
        // adding membershipType property from clubs object to addPlayer obj
        // if (!addPlayer.hasOwnProperty("membershipType")) {
        //     var clubIdx = UtilsService.getFirstIdxClubsData('clubId');
        //     var club = addPlayer.clubs
        //     let membershipType;
        //     membershipType = club && club.length > 0 ? membershipType : "";
        //     if (club && club.length > 0) {
        //         for (let i = 0; i < club.length; i++) {
        //             if (club[i].clubId === clubIdx) {
        //                 membershipType = club[i].membershipType

        //             }
        //         }
        //     }
        //     addPlayer["membershipType"] = membershipType;
        // }
        return (
            <form
                className={`add-player-wrapper ${this.props.disableallfieldsinexistsemail ? 'disable-all-fields' : ''} ${addPlayer.isPlayerEmailIdExist ? 'enable-selectbox' : ''}`}>
                <div className="position-relative">
                    {rollValue ? '' : <ErrorAlert errorMessage={`${errorMsg}`} isShow={has_error} />}
                    <h3 className="mb-3">{this.getLableHeading()}</h3>
                </div>
                <div className="add-player-inner mb-3">
                    <h4 className="mb-3">Member Information</h4>
                    <div className="d-lg-flex">
                        <div className="flex-1 pr-lg-2 mr-lg-1 w-lg-50">
                            <div className="form-group">
                                <label>Member Name <sup className="star">*</sup></label>
                                <div className="position-relative">
                                    <FormInput
                                        type="text"
                                        placeholder="Enter member name"
                                        name="fullName"
                                        value={addPlayer.fullName}
                                        submitted={this.props.submitted}
                                        errors={this.props.errors}
                                        handleChangeEvent={this.props.handleChangeEvent}
                                        onKeyPress={(e) => UtilService.alphabetsValidation(e)}
                                        onPaste={(e) => UtilService.onPastRestriction(e)}

                                    />
                                </div>
                            </div>
                            <div className="form-group">
                                {!this.state.privacyOn &&
                                    <>
                                        <label>Contact Number <sup className="star">*</sup></label>
                                        <div
                                            className={`d-flex mobile-number ${this.props.submitted && this.props.errors['mobile'] ? 'input-error' : ''}`}
                                        >
                                            <CountryCodeSelect value={addPlayer.countryCode} selectionKey={CONSTANT.COUNTRY_CODE} className="form-control border-none pr-4" name="countryCode" onSelectChange={this.props.handleChangeEvent} />

                                            <div className="position-relative flex-1">
                                                <FormInput
                                                    type="number"
                                                    className="form-control border-none"
                                                    placeholder="Enter contact number"
                                                    name="mobile"
                                                    value={parseInt(addPlayer.mobile)}
                                                    onInput={(e) => {
                                                        e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 12)
                                                    }}
                                                    // {...this.props}
                                                    submitted={this.props.submitted}
                                                    errors={this.props.errors}
                                                    handleChangeEvent={this.props.handleChangeEvent}
                                                />
                                            </div>
                                        </div>
                                    </>
                                }
                            </div>
                            <div className="form-group">
                                <label>Date of Birth </label>
                                <div className="position-relative addplayersforms">

                                    <DatePicker
                                        selected={this.props.addPlayer.dob}
                                        onChange={this.props.handleChangeDOB}
                                        dateFormat="dd MMM yyyy"
                                        placeholderText="MM-DD-YYYY"
                                        maxDate={new Date()}
                                        peekNextMonth
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                    />
                                    <svg className="calendar-icon" xmlns="http://www.w3.org/2000/svg" id="prefix__ic_calendar" width="21.575" height="21.883" viewBox="0 0 21.575 21.883">
                                        <g id="prefix__Group_6535" data-name="Group 6535">
                                            <g id="prefix__Group_6534" data-name="Group 6534">
                                                <path id="prefix__Path_5204" d="M32.26 15.849h1.233c2.466 0 3.082.616 3.082 3.082V32.8c0 2.466-.616 3.082-3.082 3.082H18.082C15.616 35.883 15 35.266 15 32.8V18.931c0-2.466.616-3.082 3.082-3.082h1.233v1.233a1.849 1.849 0 1 0 3.7 0v-1.233h5.548v1.233a1.849 1.849 0 1 0 3.7 0zm-14.486 4.315c-.925 0-1.233.308-1.233 1.233v11.712c0 .925.308 1.233 1.233 1.233H33.8c.925 0 1.233-.308 1.233-1.233V21.4c0-.925-.308-1.233-1.233-1.233zm7.4 2.157H26.4c.925 0 1.233.308 1.233 1.233v1.233c0 .925-.308 1.233-1.233 1.233h-1.229c-.925 0-1.233-.308-1.233-1.233v-1.233c0-.924.308-1.232 1.233-1.232zm5.856 0h1.23c.925 0 1.233.308 1.233 1.233v1.233c0 .925-.308 1.233-1.233 1.233h-1.233c-.925 0-1.233-.308-1.233-1.233v-1.233c0-.924.306-1.232 1.233-1.232zm-11.715 5.857h1.233c.925 0 1.233.308 1.233 1.233v1.233c0 .925-.308 1.233-1.233 1.233h-1.233c-.925 0-1.233-.308-1.233-1.233V29.41c0-.924.308-1.232 1.233-1.232zm5.856 0H26.4c.925 0 1.233.308 1.233 1.233v1.233c0 .925-.308 1.233-1.233 1.233h-1.229c-.925 0-1.233-.308-1.233-1.233V29.41c0-.924.308-1.232 1.233-1.232zm5.856 0h1.233c.925 0 1.233.308 1.233 1.233v1.233c0 .925-.308 1.233-1.233 1.233h-1.233c-.925 0-1.233-.308-1.233-1.233V29.41c0-.924.306-1.232 1.233-1.232zM21.164 14a1.194 1.194 0 0 1 1.236 1.151v2.014a1.236 1.236 0 0 1-2.466 0v-2.014A1.194 1.194 0 0 1 21.164 14zm9.246 0a1.194 1.194 0 0 1 1.233 1.151v2.014a1.236 1.236 0 0 1-2.466 0v-2.014A1.194 1.194 0 0 1 30.41 14zm-11.1 8.322h1.233c.925 0 1.233.308 1.233 1.233v1.233c0 .925-.308 1.233-1.233 1.233h-1.228c-.925 0-1.233-.308-1.233-1.233v-1.234c0-.924.308-1.232 1.233-1.232zm-.308 1.233v1.233a1.759 1.759 0 0 0 .019.289 1.759 1.759 0 0 0 .289.019h1.233a1.759 1.759 0 0 0 .289-.019 1.759 1.759 0 0 0 .019-.289v-1.234a1.759 1.759 0 0 0-.019-.289 1.759 1.759 0 0 0-.289-.019h-1.228a1.759 1.759 0 0 0-.289.019 1.759 1.759 0 0 0-.019.289z" data-name="Path 5204" transform="translate(-15 -14)" fill="#858585" fillRule="evenodd" />
                                            </g>
                                        </g>
                                    </svg>
                                </div>
                            </div>
                            <div className="form-group">
                                <label>Highest Billiards practice break <sup className="star">*</sup></label>
                                <div className="position-relative">
                                    <FormInput
                                        type="number"
                                        placeholder="Enter value "
                                        name="highestBilliardsPracticeBreak"
                                        value={addPlayer.highestBilliardsPracticeBreak}
                                        onInput={(e) => {
                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 3)
                                        }}
                                        // {...this.props}
                                        submitted={this.props.submitted}
                                        errors={this.props.errors}
                                        handleChangeEvent={this.props.handleChangeEvent}
                                    />
                                </div>
                            </div>
                            <div className="form-group">
                                <label>Highest Snooker practice break <sup className="star">*</sup></label>
                                <div className="position-relative">
                                    <FormInput
                                        type="number"
                                        placeholder="Enter value "
                                        name="highestSnookerPracticeBreak"
                                        value={addPlayer.highestSnookerPracticeBreak}
                                        onInput={(e) => {
                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 3)
                                        }}
                                        // {...this.props}
                                        submitted={this.props.submitted}
                                        errors={this.props.errors}
                                        handleChangeEvent={this.props.handleChangeEvent}
                                    />
                                </div>
                            </div>
                            
                            {!this.props.isRegister && <div className="form-group">
                                <label>Credit <sup className="star"></sup></label>
                                <div className="position-relative d-flex">
                                    <FormInput
                                        type="number"
                                        placeholder="Enter value "
                                        name="credit"
                                        value={addPlayer.credit}
                                        // {...this.props}
                                        submitted={this.props.submitted}
                                        errors={this.props.errors}
                                        handleChangeEvent={this.props.handleChangeEvent}
                                        // onKeyPress={this.isInputNumberWithPlus}
                                        onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}    
                                    />
                                    {this.props.isUpdate ? (UtilService.isClubSuperAdmin() && this.props.isOtherIdx ?null:<i className="fa fa-pencil-square-o edit_pencil" data-toggle="modal"
                                        data-target="#newproduct"></i>):''}

                                </div>
                            </div>}
                        </div>
                        <div className="flex-1 pl-lg-2 ml-lg-1 w-lg-50">
                            <div className="form-group">
                                <label>Member Address <sup className="star">*</sup></label>
                                <div className="position-relative">
                                    <div
                                        className={`form-control dashed-border text-truncate ${this.props.submitted && this.props.errors["playeraddress"]
                                            ? "input-error-dashed"
                                            : ""
                                            }`}
                                        // data-toggle="modal"
                                        // data-target="#addressForm"
                                        onClick={this.showTheModalCustom}
                                        id="addressFormValue"
                                    >
                                        <span className="address-placeholder">+ Add address details</span>

                                    </div>
                                    {this.props.submitted && this.props.errors["playeraddress"] && (
                                        <ValidationMessage message={this.props.errors["playeraddress"]} />
                                    )}
                                </div>
                            </div>
                            <div className="form-group">
                                {!this.state.privacyOn &&
                                    <>
                                        <label>Email Address <sup className="star">*</sup></label>
                                        <div className="position-relative">
                                            <FormInput
                                                type="text"
                                                placeholder="Enter email"
                                                name="email"
                                                value={addPlayer.email}
                                                // {...this.props}
                                                submitted={this.props.submitted}
                                                errors={this.props.errors}
                                                handleChangeEvent={this.props.handleChangeEvent}
                                            />
                                        </div>
                                    </>
                                }
                            </div>
                            <div className="form-group">
                                <label>Member Height (in cm) <sup className="star">*</sup></label>
                                <div className="position-relative">
                                    <FormInput
                                        type="number"
                                        placeholder="Enter height"
                                        name="height"
                                        value={addPlayer.height}
                                        onKeyDown={(evt) => ["e", "E", "+", "-", "."].includes(evt.key) && evt.preventDefault()}
                                        submitted={this.props.submitted}
                                        errors={this.props.errors}
                                        handleChangeEvent={this.props.handleChangeEvent}
                                    />
                                </div>
                            </div>
                            <div className="form-group">
                                <label>Highest Billiards tournament break<sup className="star">*</sup></label>
                                <div className="position-relative">
                                    <FormInput
                                        type="number"
                                        placeholder="Enter value "
                                        name="highestBilliardsTournamentBreak"
                                        value={addPlayer.highestBilliardsTournamentBreak}
                                        onInput={(e) => {
                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 3)
                                        }}
                                        // {...this.props}
                                        submitted={this.props.submitted}
                                        errors={this.props.errors}
                                        handleChangeEvent={this.props.handleChangeEvent}
                                    />
                                </div>
                            </div>
                            <div className="form-group">
                                <label>Highest Snooker tournament break<sup className="star">*</sup></label>
                                <div className="position-relative">
                                    <FormInput
                                        type="number"
                                        placeholder="Enter value"
                                        name="highestSnookerTournamentBreak"
                                        value={addPlayer.highestSnookerTournamentBreak}
                                        onInput={(e) => {
                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 3)
                                        }}
                                        // {...this.props}
                                        submitted={this.props.submitted}
                                        errors={this.props.errors}
                                        handleChangeEvent={this.props.handleChangeEvent}
                                    />
                                </div>
                            </div>
                            {!this.props.isRegister && <div className="form-group">
                                <label>Discount(%)<sup className="star"></sup></label>
                                <div className="position-relative">
                                    <input
                                        id={`member_credit${disable_class}`}
                                        pattern="/^[0-9]*\.[0-9]{2}$ or ^[0-9]*\.[0-9][0-9]$/"
                                        className={`form-control member_credit`}
                                        type="number"
                                        placeholder="Enter value"
                                        name="discount"
                                        value={addPlayer?.discount}
                                        onKeyPress={this.isInputNumber}
                                        // {...this.props}
                                        submitted={this.props.submitted}
                                        errors={this.props.errors}
                                        onChange={this.props.handleChangeEvent}
                                    />
                                </div>
                            </div>}

                        </div>
                        
                    </div>

                    <div className="d-lg-flex">
                        <div className="flex-1 pr-lg-2 mr-lg-1 d-xl-flex">
                            <div
                                className="form-group mr-5">
                                <label>Gender </label>
                                <div className="position-relative">
                                    <div className="radio-btn d-flex">
                                        <div className="position-relative mr-3">
                                            <input type="radio" id="selectGander1" name="gender" onChange={this.props.handleChangeEvent} value="M" checked={addPlayer.gender === "M"} />
                                            <svg className="radio-checked" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                                <path d="M12 7a5 5 0 1 0 5 5 5 5 0 0 0-5-5zm0-5a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z" data-name="Path 5239" fill="#b52830" />
                                                <path d="M0 0h24v24H0z" data-name="Path 5240" fill="none" />
                                            </svg>
                                            <svg className="radio-unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                                <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z" data-name="Path 5241" fill="#666" />
                                                <path d="M0 0h24v24H0z" data-name="Path 5242" fill="none" />
                                            </svg>
                                            <label className="d-block m-0" htmlFor="selectGander1">
                                                Male
                                            </label>
                                        </div>
                                        <div className="position-relative">
                                            <input type="radio" id="selectGander2" value="F" name="gender" onChange={this.props.handleChangeEvent} checked={addPlayer.gender === "F"} />
                                            <svg className="radio-checked" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                                <path d="M12 7a5 5 0 1 0 5 5 5 5 0 0 0-5-5zm0-5a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z" data-name="Path 5239" fill="#b52830" />
                                                <path d="M0 0h24v24H0z" data-name="Path 5240" fill="none" />
                                            </svg>
                                            <svg className="radio-unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                                <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z" data-name="Path 5241" fill="#666" />
                                                <path d="M0 0h24v24H0z" data-name="Path 5242" fill="none" />
                                            </svg>
                                            <label className="d-block m-0" htmlFor="selectGander2">
                                                Female
                                            </label>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div
                                className="form-group">
                                <label>Style</label>
                                <div className="position-relative">
                                    <div className="radio-btn d-flex">
                                        <div className="position-relative mr-2">
                                            <input type="radio" id="rightHand" value="R" name="styleOfPlaying" onChange={this.props.handleChangeEvent} checked={addPlayer.styleOfPlaying === "R"} />
                                            <svg className="radio-checked" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                                <path d="M12 7a5 5 0 1 0 5 5 5 5 0 0 0-5-5zm0-5a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z" data-name="Path 5239" fill="#b52830" />
                                                <path d="M0 0h24v24H0z" data-name="Path 5240" fill="none" />
                                            </svg>
                                            <svg className="radio-unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                                <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z" data-name="Path 5241" fill="#666" />
                                                <path d="M0 0h24v24H0z" data-name="Path 5242" fill="none" />
                                            </svg>
                                            <label className="d-block m-0" htmlFor="rightHand">
                                                Right Hand
                                            </label>
                                        </div>
                                        <div className="position-relative mr-2">
                                            <input type="radio" id="leftHand" value="L" name="styleOfPlaying" onChange={this.props.handleChangeEvent} checked={addPlayer.styleOfPlaying === "L"} />
                                            <svg className="radio-checked" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                                <path d="M12 7a5 5 0 1 0 5 5 5 5 0 0 0-5-5zm0-5a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z" data-name="Path 5239" fill="#b52830" />
                                                <path d="M0 0h24v24H0z" data-name="Path 5240" fill="none" />
                                            </svg>
                                            <svg className="radio-unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                                <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z" data-name="Path 5241" fill="#666" />
                                                <path d="M0 0h24v24H0z" data-name="Path 5242" fill="none" />
                                            </svg>
                                            <label className="d-block m-0" htmlFor="leftHand">
                                                Left Hand
                                            </label>
                                        </div>
                                        { UtilService.isPabsaAdmin() &&  <div className="">
                            <div className="d-flex align-items-center position-relative">
                                <div className="position-relative red-checkbox">
                                    <label
                                        className="form-check-label position-relative d-flex"
                                        htmlFor="exampleCheck1"
                                    >
                                        <input
                                            type="checkbox"
                                            className="form-check-input checkbox-element"
                                            name="isReferee"
                                            checked={addPlayer.isReferee}
                                            // disabled={this.props.isUpdate ? true : false}
                                            onChange={this.props.handleChangeEvent}
                                        />
                                        <span className="checkmark mr-2"></span>
                                        Can be a Referee
                                    </label>
                                </div>
                            </div>
                            </div>}
                                    </div>

                                </div>
                            </div>
                      
                        </div>


                        <div className="flex-1 pl-lg-2 ml-lg-1 w-lg-50">
                            <div className="form-group">
                                <label htmlFor="currencyType">
                                    Currency
                                </label>
                                <div className="position-relative">
                                    <div class="form-group">
                                        <select
                                            className="form-control"
                                            name="currency"
                                            aria-label="Select Currency"
                                            id="currencyType"
                                            onChange={this.props.handleChangeEvent}
                                            value={addPlayer.currency}
                                        // submitted={this.props.submitted}
                                        >
                                            <option value="">Select</option>
                                            {this.state.currenciesData.map((key, idx) => {
                                                return <option key={idx} value={key.currencyCode}>{key.currency}</option>
                                            })}
                                        </select>
                                        <i className="arrow-icon"></i>
                                    </div>
                                    {/* {this.props.submitted && this.props.errors["currency"] && (
                                        <ValidationMessage message={this.props.errors["currency"]} />
                                    )} */}
                                </div>
                            </div>
                        </div>
                    </div><div className="row">
                        {!isRegister && (
                            <div className="col-sm-12 col-md-6">
                                {organizationWithClub}
                            </div>
                        )}
                        {!isRegister && addPlayer.associate_player &&
                            <div className="col-sm-12 col-md-6 membership">
                                <div className="flex-1 pl-lg-0 ml-lg-0 w-lg-100">
                                    <div className="form-group">
                                        <label htmlFor="membershipType">
                                            Membership Type<sup className="star">*</sup>
                                        </label>
                                        <div className="position-relative">
                                            <div class="form-group">
                                                <select
                                                    className="form-control enable-select"
                                                    name="membershipType"
                                                    aria-label="Select membership"
                                                    id="membershipType"
                                                    onChange={this.props.handleChangeEvent}
                                                    value={addPlayer.membershipType}
                                                // submitted={this.props.submitted}
                                                >
                                                    {/* <option value="">Select</option> */}
                                                    <option name="hourly" value="HOURLY">Hourly</option>
                                                    <option name="monthly" value="MONTHLY">Monthly</option>
                                                    <option name="yearly" value="YEARLY">Yearly</option>
                                                </select>
                                                <i className="arrow-icon"></i>
                                            </div>
                                            {this.props.submitted && this.props.errors["membershipType"] && (
                                                <ValidationMessage message={this.props.errors["membershipType"]} />
                                            )}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        }
                    </div>

                </div>
                <div className="d-flex justify-content-end align-items-center">
                    {isRegister ?
                        <button type="button" className="btn back-btn" data-dismiss="modal" aria-label="Close" onClick={this.props.resetAllFields}>Cancel</button> :
                        <button type="button" className="btn cancel-btn" onClick={() => { this.props.back_press() }}>Back</button>}

                    <div className="position-relative">
                        <div className={isLoading ? "loader" : null}></div>
                        <input type="button"
                            className={`btn red-btn ml-3 ${isLoading ? "pointer-event disabled " : null}`}
                            onClick={this.props.onAddPlayerSubmit.bind(this)}
                            value={this.props.isUpdate ? 'Update' : 'Save'} />
                    </div>
                </div>
                <div
          class="modal fade"
          id="newproduct"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div class="d-table w-100">
            <div class="d-table-cell">
              <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                  <button
                    type="button"
                    class="close popup-close-btn"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                    >
                      <path
                        d="M5.314 6.829l5.671 5.671-5.671 5.67a1.071 1.071 0 001.515 1.515l5.671-5.67 5.671 5.671a1.071 1.071 0 001.515-1.515L14.015 12.5l5.671-5.671a1.071 1.071 0 00-1.516-1.515l-5.67 5.671-5.671-5.671a1.071 1.071 0 00-1.515 1.515z"
                        transform="translate(-5 -5)"
                        fill="#666"
                      ></path>
                    </svg>
                  </button>
                  <div class="modal-body p-0 border-0 mb-0">
                    <h5
                      class="modal-title text-center mb-3"
                      id="exampleModalLongTitle"
                    >
                      Add Credit 
                    </h5>
                    <div class="d-flex flex-column">
                      <div class="table-row">
                        <div class="form-group">
                          <label>
                            Credit Amount <sup class="star"></sup>
                          </label>
                          <div class="d-flex mobile-number">
                            <div class="position-relative dollar">
                              <i>$</i>
                            </div>
                            <div class="position-relative flex-1">
                            <input
                                id = "member_credit"
                                type="number"
                                class="form-control border-none"
                                placeholder="Enter value"
                                name="amount"
                                value={this.state.priceValue}
                                onChange={this.handlePriceChange}
                                // onKeyPress={this.isInputNumberWithPlus}
                                onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}                     
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer p-0 mt-2 border-none">
                    <button
                      type="button"
                      class="btn cancel-btn"
                      data-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      class={`btn red-btn ml-3 ${
                        !this.state.addValidate
                          ? "pointer-event disabled "
                          : null
                      }`}
                      data-dismiss="modal"
                      onClick={this.addProductPrice}
                    >
                      Save
                    </button>
                  </div>{" "}
                </div>
              </div>
            </div>
          </div>
        </div>

                <div className="modal fade" id="confirmationPlayer" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="d-table w-100">
                        <div className="d-table-cell">
                            <div className="modal-dialog  modal-dialog-centered" role="document">
                                {hideUser && !isRegister && (
                                    <div className="modal-content">
                                        <button type="button" className="close popup-close-btn" data-dismiss="modal" aria-label="Close">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15"><path d="M5.314 6.829l5.671 5.671-5.671 5.67a1.071 1.071 0 001.515 1.515l5.671-5.67 5.671 5.671a1.071 1.071 0 001.515-1.515L14.015 12.5l5.671-5.671a1.071 1.071 0 00-1.516-1.515l-5.67 5.671-5.671-5.671a1.071 1.071 0 00-1.515 1.515z" transform="translate(-5 -5)" fill="#666"></path></svg>
                                        </button>
                                        <div className="modal-body p-0 pt-3 text-center">
                                            <p className="m-0 mb-1">A Member is already registered with</p>
                                            <strong className="mb-1 d-block">{this.props.addPlayer.email}</strong>
                                            <p className="m-0">Do you want to register the same member in the club?</p>
                                        </div>
                                        <div className="modal-footer p-0 mt-4 border-none justify-content-center">
                                            <button type="button" className="btn cancel-btn" data-dismiss="modal">No</button>
                                            <button type="button" className="btn red-btn ml-3" onClick={this.props.getalreadyexistsplayerinfo} data-dismiss="modal">Yes</button>
                                        </div>
                                    </div>
                                )}
                                {!hideUser && !isRegister && (
                                    <div className="modal-content">
                                        <button type="button" className="close popup-close-btn" data-dismiss="modal" aria-label="Close">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15"><path d="M5.314 6.829l5.671 5.671-5.671 5.67a1.071 1.071 0 001.515 1.515l5.671-5.67 5.671 5.671a1.071 1.071 0 001.515-1.515L14.015 12.5l5.671-5.671a1.071 1.071 0 00-1.516-1.515l-5.67 5.671-5.671-5.671a1.071 1.071 0 00-1.515 1.515z" transform="translate(-5 -5)" fill="#666"></path></svg>
                                        </button>
                                        <div className="modal-body p-0 pt-3 text-center">
                                            <p className="m-0 mb-1">A user is already registered with</p>
                                            <strong className="mb-1 d-block">{this.props.addPlayer.email}</strong>
                                            <p className="m-0">Please use different email address to continue.</p>
                                        </div>
                                        <div className="modal-footer p-0 mt-4 border-none justify-content-center">
                                            <button type="button" className="btn red-btn" data-dismiss="modal">OK</button>
                                        </div>
                                    </div>
                                )}
                                {isRegister && (!hideUser || hideUser) && (
                                    <div className="modal-content">
                                        <button type="button" className="close popup-close-btn" onClick={this.hideConfirmModal} aria-label="Close">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15"><path d="M5.314 6.829l5.671 5.671-5.671 5.67a1.071 1.071 0 001.515 1.515l5.671-5.67 5.671 5.671a1.071 1.071 0 001.515-1.515L14.015 12.5l5.671-5.671a1.071 1.071 0 00-1.516-1.515l-5.67 5.671-5.671-5.671a1.071 1.071 0 00-1.515 1.515z" transform="translate(-5 -5)" fill="#666"></path></svg>
                                        </button>
                                        <div className="modal-body p-0 pt-3 text-center">
                                            <p className="m-0 mb-1">This email address is already registered.</p>
                                            <p className="m-0">Please use different email address to continue.</p>
                                        </div>
                                        <div className="modal-footer p-0 mt-4 border-none justify-content-center">
                                            <button type="button" className="btn red-btn" onClick={this.hideConfirmModal}>OK</button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}
